<template>
  <div class="Serve-container">
    <div class="Serve-title">综合数据服务</div>
    <div class="Serve-list">
       
        <div class="list-item" v-for="(it,index) in list" :key="index">
            <img class="logo" :src="it.img" alt="">
            <p class="item-title">{{it.title}}</p>
            <p class="item-content">{{it.content}}</p>
        </div>

    </div>
  </div>
</template>

<script>
import img1 from "@/assets1/首页_slices (1)/通用性.png" 
import img2 from "@/assets1/首页_slices (1)/可用性.png" 
import img3 from "@/assets1/首页_slices (1)/可扩展性.png" 
export default {

data(){
    return{
        list:[{
            title:'数据标注',
            content:'为企业提供高质量的数据标注服务，涵盖图像、文本、音频和视频，自然语义等多种数据类型。',
            img:img1
        },
        {
            title:'数据采集',
            content:'数循提供标准或定制化的数据采集服务. 采集后数据经过清洗、整理和分析后, 能够为企业决策提供可靠依据.',
            img:img2
        },
        {
            title:'AI模型训练',
            content:'为企业提供从数据准备到模型部署的全部流程服务. 包括数据清洗和标注、模型选择与设计、训练与优化、测试与评估等环节.',
            img:img3
        }
        ]
    }
}
}
</script>

<style scoped>
.Serve-title{
    /* margin-top: 40px;
      
    font-size:33px ;
    font-weight: 500; */

font-family: Medium;
font-weight: 500;
font-size: 36px;
color: #17213C;
font-style: normal;
margin-bottom: 60px;
}
.logo{
    width: 80px;
    height: 80px;
    object-fit: cover;
    /* margin: 0 auto; */
}
.Serve-container{
padding-top: 100px;
min-width:1920px ;
padding-bottom: 100px;

background: #F9FAFD;
text-align: center;
}
.Serve-list{
    display: flex;
    justify-content: center;
}
.list-item{
    width: 380px;

    display: flex;
    flex-direction: column;
    /* justify-content: center; */
    align-items: center;
    text-align: center;
    padding: 0 20px;
}
.item-title{
    /* margin-top: 20px;
    font-size: 15px;
    font-weight: 500;
    margin-bottom: 10px; */
    margin-top: 30px;
     margin-bottom: 15px;
font-family: Medium;
font-weight: 500;
font-size: 18px;
color: #17213C;
line-height: 25px;

font-style: normal;
}
.item-content{
    font-family: Regular;
    font-size: 15px;
    color: #99a3ab;
     letter-spacing:1px;
}
</style>